import { EventTracker } from './event-tracker'

export class LoggingEventTracker implements EventTracker {
  async identify(): Promise<void> {
    // No-op in production
  }

  track(): void {
    // No-op in production
  }

  reset(): void {
    // No-op in production
  }
}
